import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SaveErpOrderNFeInput } from './SaveErpOrderNFeInput';
import { SaveErpOrderNFeOutput } from './SaveErpOrderNFeOutput';

export class SaveErpOrderNFeService extends HttpServiceBase {

  handle = (input: SaveErpOrderNFeInput): Promise<Result<SaveErpOrderNFeOutput> | null> => {
    const promise = this.http.post<Result<SaveErpOrderNFeOutput>, SaveErpOrderNFeInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-order-nfe`,
      input
    );
    return promise;
  }
}
